import { MenuItem } from "@shopify/hydrogen/storefront-api-types"
import FacebookIcon from "~/assets/icons/FacebookIcon"
import InstagramIcon from "~/assets/icons/InstagramIcon"
import LinkedinIcon from "~/assets/icons/LinkedinIcon"
import MailHeader from "~/assets/icons/MailHeader"
import PhoneHeader from "~/assets/icons/PhoneHeader"
import PinterestIcon from "~/assets/icons/PinterestIcon"
import TwitterIcon from "~/assets/icons/TwitterIcon"
import VisitHeader from "~/assets/icons/VisitHeader"
import YoutubeIcon from "~/assets/icons/YoutubeIcon"
import { Drawer } from "~/rs-components/global"
import Navigation from "~/rs-components/global/navigation/Navigation.client"
import SearchIcon from "../assets/search"
import { contactInfo } from "../settings"
import WishButtonIcon from "../custom_icons/WishButtonIcon"
import { wishlistButtonNextTitle, routeWishList } from "../settings/__product"
import FinanceIcon from "../assets/fianance"
import GuaranteeIcon from "../assets/guarantee"
import SuportIcon from "../assets/support"
import UkIcon from "../assets/ukIcon"
import { TruspilotMobile } from "./TruspilotHeader.client"
import TrustPilotManagement from "~/rs-components/home/TrustPilotManagement.client"
import Facebook from "../assets/facebook"
import Instagram from "../assets/instagram"
import Twitter from "../assets/Tiktok"
import Youtube from "../assets/youtube"

type SetupMenuDrawerProps = {
    onClose: () => void,
    showCategory: string | boolean,
    setShowCategory: React.Dispatch<React.SetStateAction<string | boolean>>,
    goTo: (path: string) => void,
    storeName: string,
    menuItems: MenuItem[],
    shopSettings: any
}

export default function SetupMenuDrawer({ onClose, showCategory, setShowCategory, goTo, storeName, menuItems, shopSettings }: SetupMenuDrawerProps) {
    return (
        <>

            <div className="grid">
                <nav className="grid gap-4 p-6 sm:gap-6 sm:px-12 sm:py-8">

                    <div className="topUserAreaResponsive open loginCart basis-3/12 text-right mb-10">
                        <div className="topUserAreaResponsive__search-container">
                            <div className="topUserAreaResponsive__search">
                                <form action={`/products`} method="GET">
                                    <input name="search" type="search" placeholder="Search..." />
                                    <i className="fa fa-search">
                                        <button type='submit' className='buttonSearch'>
                                            <SearchIcon />
                                        </button>
                                    </i>
                                </form>
                            </div>
                        </div>
                    </div>

                    <Navigation css={""} menuItems={menuItems} showCategory={showCategory} setShowCategory={setShowCategory} onClose={onClose} mobile shopSettings={shopSettings} />

                    <div className="subBtns ">                       
                        <div className="subMenu__item lineGrey madeUK trustMobile">
                            <a href="https://uk.trustpilot.com/review/www.kcsofas.co.uk?utm_medium=trustbox&utm_source=Horizontal" target="blank">
                                <img src="https://cdn.shopify.com/s/files/1/0625/0240/4246/files/TRUSTPILOT_2.svg?v=1725652390" alt="" />                               
                            </a>
                        </div>

                        <div className="subMenu__item lineGrey madeUK">
                            <a href="/page/made-in-the-uk">
                                <img src="https://cdn.shopify.com/s/files/1/0625/0240/4246/files/Frame_11.svg?v=1725562335" alt="" />
                                <p>Made in the UK*</p>
                            </a>
                        </div>

                        <div className="subMenu__item lineGrey frameGuarantee">
                            <a href="/page/guarantee">
                                <GuaranteeIcon />
                                <p>10-year Frame Guarantee</p>
                            </a>
                        </div>

                        <div className="subMenu__item lineGrey financeAvailabe">
                            <a href="/page/finance">
                                <FinanceIcon />
                                <p>Finance Available</p>
                            </a>
                        </div>

                        <div className="subMenu__item contactPhone">
                            <SuportIcon />
                            <p>0330 124 4736</p>
                        </div>
                    </div>

                    <div className="wishListResonsive">
                        {wishlistButtonNextTitle &&
                            <div className="topUserArea__login">
                                <a href={routeWishList}><WishButtonIcon />Wishlist</a>
                            </div>
                        }
                    </div>
                    <div className="iconsInformation">
                        <a className="iconsInformation__call" href={`tel:${contactInfo?.phone}`}><i><PhoneHeader /></i>Call {contactInfo?.phone}</a>
                        <a className="iconsInformation__email" href={`mailto:${contactInfo?.mailTo}`}><i><MailHeader /></i>Email us</a>
                        <a className="iconsInformation__visit" href="/page/store-locator"><i><VisitHeader /></i>Visit us</a>
                    </div>

                    <div className="responsiveMenu__socialIcons">
                    <a href="https://en-gb.facebook.com/KCSofasCastleford/" target="blank"><Facebook></Facebook></a>
                        <a href="https://www.instagram.com/kcsofas/" target="blank"><Instagram></Instagram></a>
                        <a href="https://twitter.com/kcsofas" target="blank"><Twitter></Twitter></a>
                        <a href="https://www.youtube.com/@kcsofas7872/videos" target="blank"><Youtube></Youtube></a>
                    </div>
                    <div className="logosFooter__wrapper">
                        
                    </div>

                </nav>

            </div>
        </>
    )
}